var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"}},[_c('path',{attrs:{"d":"M2 22V17.35L10.75 5.55L9 3.2L10.6 2L12 3.875L13.4 2L15 3.2L13.25 5.55L22 17.35V22H2ZM12 7.225L4 18V20H7L12 13L17 20H20V18L12 7.225ZM9.45 20H14.55L12 16.45L9.45 20Z","fill":"#031425"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }